import { Icon } from '@fourthwall/components';
import { PlusIcon } from '@fourthwall/icons';
import React from 'react';
import * as S from './AddPodcastButton.styled';
export const AddPodcastButton = ({ onClick }) => (React.createElement(S.Container, { type: "button", onClick: onClick },
    React.createElement(Icon, { component: PlusIcon, height: 16 }),
    "Add new podcast"));
